/**
 * Vendor live map is available once dispatch has progressed past initial scheduling states.
 * Mirrors logic previously in ServiceDetailsSegment.canTrackVendor.
 */
const NON_TRACKABLE_STATUSES = [
  'pending',
  'vendor_not_accepted',
  'scheduled',
  'awaiting_customer_payment',
];

export function serviceStatusAllowsVendorTracking(status) {
  return Boolean(status && !NON_TRACKABLE_STATUSES.includes(status));
}

export function getVendorTrackingPath(serviceId) {
  if (serviceId == null || serviceId === '') return null;
  return `/vendor-tracking/${serviceId}`;
}
